import { Controller } from "@hotwired/stimulus"
import { writePlacementSlots } from "../utils/trip_add_slots"

export default class extends Controller {
  static values = { thingId: String }

  preserve() {
    writePlacementSlots(this.element, this.thingIdValue)
  }
}
